import DataServiceSQL from "../DataService/DataServiceSQL";

//Function to convert FHIR devices
const convert_fhir_devices = (device_list) => {
  let ret = []
  device_list.entry.forEach(device => {
    if (device.type.text !== "Gateway") {
    let new_device =
      {
        id_device: device.identifier,
        nickname: device.name.value,
        sn: device.serialNumber
      }
      if (device.type.text === "AOJ-20A") {
        new_device.type = "Tucky"
      }
      else {
        new_device.type = device.type.text
      }
      ret.push(new_device)
    }
  })
  return ret
}

//Function to retrieve SQL device list
const get_device_list = async (struct_Id) => {
    return await DataServiceSQL.getAllDeviceReq_fhir(struct_Id)
      .then((response) => {
        if((response.data !== false)&&(response.data.length !==0)){
          return(response.data);
        }
        else{
          return("none");
        }

      })
      .catch((e) => {
        console.log(e);
      });
};

//Function to retrieve one SQL device by criteria
const get_device_by_criteria = async (criteria, value) => {
    return await DataServiceSQL.findDeviceReq_fhir(criteria, value)
      .then((response) => {
        if(response.data.length !==0 ){
          let device_list = DeviceFunctionsGetter.convert_fhir_devices(response.data)
          return(device_list);
        }
        else{
          return("none");
        }
      })
      .catch((e) => {
        console.log(e);
      });
};

//Const to import functions in other files
const DeviceFunctionsGetter = {
  convert_fhir_devices,
  get_device_list,
  get_device_by_criteria
};

export default DeviceFunctionsGetter;